import React from "react";
import { Box, Button, Divider, Grid, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

interface IEditProfileTitleProps {
  back: () => void;
}

const EditProfileTitle: React.FC<IEditProfileTitleProps> = ({ back }) => {
  return (
    <Grid item xs={12}>
      <Box display="flex" justifyContent="space-between" alignItems="center" mt={2} mb={1}>
        <Typography variant="h6" color="primary" fontWeight={600}>
          Editar Permissões do Perfil de Acesso
        </Typography>

        <Button
          variant="text"
          color="primary"
          onClick={back}
          startIcon={<ArrowBackIcon />}
          sx={{ fontWeight: 500 }}
        >
          Voltar
        </Button>
      </Box>

      <Divider />
    </Grid>
  );
};

export default EditProfileTitle;
